import { render, staticRenderFns } from "./UiUploader.vue?vue&type=template&id=c86f4044&lang=pug&"
import script from "./UiUploader.vue?vue&type=script&lang=js&"
export * from "./UiUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports